module.exports = __webpack_public_path__ + "img/dance-test-icon5.5fbb16b0.png";